import React from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';

import { Button } from '@gumtree/ui-library';
import { trackV2 } from '@gumtree/shared/src/util/track-ga-event';

import { resetFiltersThunk } from '../../../reducers/current-filter-states';
import type { SrpUseDispatch } from '../../../reducers';

interface ClearFiltersButtonProps {
    isFillWidth?: boolean;
}

const StyledButton = styled(Button)`
    ${({ fullWidth }) => (fullWidth ? 'border: none' : '')}
`;

const ClearFiltersButton = ({ isFillWidth = false }: ClearFiltersButtonProps) => {
    const dispatch = useDispatch() as SrpUseDispatch;

    const onClickHandler = () => {
        dispatch(resetFiltersThunk());
        trackV2('SRP-refine-modal-clear');
    };

    return (
        <StyledButton
            onClick={onClickHandler}
            fullWidth={isFillWidth}
            display="tertiary"
            label="Clear filters"
        />
    );
};

export default ClearFiltersButton;
